import {createSvgIcon} from "@mui/material";

const ChevronRightIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M8.33008 5L13.3301 10L8.33008 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>,
  'ChevronRight'
)

export default ChevronRightIcon;
